import { Command, ShiftData } from '@nextforce/api'
import { Input, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { SafeAreaView } from 'react-native-safe-area-context'
import { CommandButtons } from 'shared/components/command_buttons'
import { UserShiftCard } from 'shared/components/shift/user_shift_card'

interface Props {
  shiftData: ShiftData
  onCommandButtonPress(command: Command): Promise<void>
  customMessage: string | undefined
  setCustomMessage(message: string): void
}

export default function ConfirmShiftActionView({
  shiftData,
  onCommandButtonPress,
  customMessage,
  setCustomMessage,
}: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={{ flex: 1 }}>
      <KeyboardAwareScrollView
        keyboardShouldPersistTaps={'handled'}
        contentContainerStyle={styles.container}
        enableOnAndroid={true}
      >
        <View>
          {shiftData.statusMessages.primary && (
            <Text style={styles.primaryStatusMessage}>
              {shiftData.statusMessages.primary}
            </Text>
          )}
          {shiftData.statusMessages.secondary && (
            <Text style={styles.secondaryStatusMessage}>
              {shiftData.statusMessages.secondary}
            </Text>
          )}
          {shiftData.type === 'COVER' &&
          shiftData?.candidates &&
          shiftData?.candidates?.length !== 0 ? null : (
            <>
              {shiftData.shift && (
                <View>
                  <Text style={styles.shiftDetailsText}>SHIFT DETAILS</Text>
                  <UserShiftCard shift={shiftData.shift} />
                </View>
              )}
            </>
          )}

          {shiftData?.candidates && shiftData?.candidates?.length !== 0 && (
            <UserShiftCard shift={shiftData?.candidates[0].shift!} />
          )}
          {isCoverRequest(shiftData.shift?.commands) ? (
            <View style={{ padding: 10 }}>
              <Text style={styles.coverRequestTitle}>
                {t('coverRequestMessageTitle')}
              </Text>
              <View style={styles.inputContainer}>
                <Input
                  style={styles.input}
                  placeholder={t('messagePlaceholder')}
                  value={customMessage}
                  onChangeText={text => setCustomMessage(text)}
                  multiline
                />
              </View>
            </View>
          ) : null}
        </View>

        <View style={styles.buttonView}>
          <CommandButtons
            commands={shiftData.shift?.commands}
            onButtonPress={onCommandButtonPress}
          />
          <CommandButtons
            commands={shiftData?.commands}
            onButtonPress={onCommandButtonPress}
          />
        </View>
      </KeyboardAwareScrollView>
    </SafeAreaView>
  )
}

function isCoverRequest(commands?: Command[]) {
  if (!commands) return false
  return commands.some(
    command => command.type === 'action' && command.name === 'store_chat'
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },

  primaryStatusMessage: {
    color: theme.colors?.black,
    fontSize: 16,
    fontFamily: font.bold,
    textAlign: 'justify',
    padding: 10,
    borderBottomColor: theme.colors?.grey3,
    borderBottomWidth: 0.5,
  },
  secondaryStatusMessage: {
    color: theme.colors?.grey2,
    fontSize: 15,
    fontFamily: font.normal,
    textAlign: 'justify',
    padding: 10,
    borderBottomColor: theme.colors?.grey3,
    borderBottomWidth: 0.5,
  },
  shiftDetailsText: {
    fontSize: 14,
    margin: 10,
  },
  buttonView: {
    padding: 10,
  },
  inputContainer: {
    backgroundColor: 'white',
    margin: 10,
  },
  input: {
    height: 100,
    textAlignVertical: 'top',
    padding: 10,
    borderWidth: 1,
    borderColor: theme.colors?.grey5,
  },
  coverRequestTitle: {
    padding: 10,
    fontFamily: font.bold,
    fontSize: 15,
  },
}))
